import useOpenUpdateLeadModalEventHandler from 'components/domain/lead/events/useOpenUpdateLeadModalEventHandler';
import useOpenCreateLeadModalEventHandler from '../components/domain/lead/events/useOpenCreateLeadModalEventHandler';

const useAppGlobalEventHandlers = () => {
  useOpenCreateLeadModalEventHandler();
  useOpenUpdateLeadModalEventHandler();
};

export default useAppGlobalEventHandlers;
